import { dashboardsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import axios, { isAxiosError } from "axios";
import { Tile } from "@src/cloud-connect/blueprint/dashboards/entities/tile";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

interface UpdateDashboardDto {
  dashboard_id: string;
  data: {
    tiles: Tile[];
  };
  name?: string;
  namespace?: string;
  source_id: string;
}

const isRefreshTokenExpiredResponse = (err: unknown): boolean => {
  if (!isAxiosError(err)) return false;

  const data = err.response?.data;
  const message =
    typeof data === "string" ? data : data?.message ?? data?.detail;

  return (
    typeof message === "string" && message.includes("Refresh Token is expired")
  );
};

export const updateDashboard = async (dto: UpdateDashboardDto) => {
  const url = dashboardsUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();
  const namespace = dto.namespace;
  console.log("Updating dto:", dto);
  const payload = {
    name: dto.name ? dto.name : "",
    namespace,
    source_id: dto.source_id,
    data: dto.data,
  };

  try {
    const response = await axios.put(
      `${url}/api/v1/ns/${namespace}/sources/${dto.source_id}/dashboards/${dto.dashboard_id}`,
      payload,
      { headers },
    );
    return response.data;
  } catch (err) {
    if (isRefreshTokenExpiredResponse(err)) {
      navigateTo(Route.TOKENS_EXPIRED_ERROR);
      return;
    }

    if (isAxiosError(err)) {
      console.error("Axios error:", err);
    }
    navigateTo(Route.SERVER_ERROR);
  }
};
